export default "__VITE_ASSET__gekGdFqB__"